import { FormParams, FormParamValueType, FormValues } from '@models/form';

export function findSettingValue<T extends FormParamValueType = string>(
    settingArray: FormParams = [],
    searchKey = ''
): T | undefined {
    if (!Array.isArray(settingArray)) {
        return undefined;
    }

    const setting = settingArray.find(({ key }) => key && key.toLowerCase() === searchKey.toLowerCase());

    if (setting) {
        return setting.value as T;
    }

    return undefined;
}

export function sendToMarketo(formValues: FormValues): boolean {
    const marketoCountries = ['GB', 'AU', 'PT', 'PL', 'DE', 'IT', 'FR', 'IE', 'NL'];

    if (formValues['fleet_size'] && formValues['country']) {
        if (formValues['fleet_size'] === '1-49' && marketoCountries.includes(formValues['country'] as string)) {
            return true;
        }
    }

    return false;
}
